var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cn } from '@lux/core';
var LoaderWrapper = function (props) {
    var className = props.className, rest = __rest(props, ["className"]);
    return (React.createElement("div", __assign({ className: cn('gap-y-s gap-x-m flex h-full flex-nowrap justify-between', 'sm:gap-y-s sm:gap-x-xs', className) }, rest)));
};
var SkeletonLoader = function (props) {
    var width = props.width, _a = props.cardHeight, cardHeight = _a === void 0 ? 150 : _a, className = props.className, style = props.style, rest = __rest(props, ["width", "cardHeight", "className", "style"]);
    var baseGradients = [
        'linear-gradient(90deg, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 100%)',
        'linear-gradient(#f3f3f3 250px, transparent 0)',
        'linear-gradient(#f3f3f3 15px, transparent 0)',
        'linear-gradient(#f3f3f3 13px, transparent 0)',
        'linear-gradient(#f3f3f3 15px, transparent 0)',
        'linear-gradient(white 100%, transparent 0)',
    ].join(',');
    var mergedStyle = __assign(__assign({}, style), { width: "".concat(width, "px"), minWidth: "".concat(width, "px"), minHeight: "".concat(cardHeight, "px"), backgroundImage: baseGradients, backgroundSize: '120px 325px, 190px 250px, 130px 40px, 120px 40px, 90px 40px, 100% 100%', backgroundPosition: '-250% 0, 0px 0px, 0px 258px, 0px 280px, 0px 300px, 0 0' });
    return (React.createElement("div", __assign({ className: cn('animate-skeletonGradientShift h-full', className), style: mergedStyle }, rest)));
};
export var CardsSkeletonLoader = function (_a) {
    var width = _a.width, itemsCount = _a.itemsCount, cardHeight = _a.cardHeight;
    var loaderCards = [];
    for (var i = 0; i < itemsCount; i++) {
        loaderCards.push(React.createElement(SkeletonLoader, { key: "".concat(i, "_loaderCard"), width: width, cardHeight: cardHeight }));
    }
    return React.createElement(LoaderWrapper, null, loaderCards);
};
